"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sizes = require("@decisiv/design-tokens/lib/iconography/sizes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SvgExclamationShield32 = function SvgExclamationShield32(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutProperties(_ref, ["size", "color"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    width: _sizes.alias[size],
    height: _sizes.alias[size],
    color: color,
    focusable: "false"
  }, props), _react.default.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, _react.default.createElement("circle", {
    fillRule: "nonzero",
    cx: 24,
    cy: 27,
    r: 1
  }), _react.default.createElement("path", {
    d: "M24 20a1 1 0 00-1 1v3a1 1 0 002 0v-3a1 1 0 00-1-1z"
  }), _react.default.createElement("path", {
    d: "M32 12V3.5a1 1 0 00-1-1L16 0 .76 2.53A1 1 0 000 3.5V12a20.77 20.77 0 001.1 5.46 26.91 26.91 0 001.66 3.85 26.87 26.87 0 002.4 3.6 24.52 24.52 0 002.48 2.58 21.87 21.87 0 005 3.27 23.77 23.77 0 003 1.16 1 1 0 00.78 0 23.77 23.77 0 003-1.16l.19-.1A7.89 7.89 0 0024 32a8 8 0 006.3-12.92c.22-.52.43-1.08.6-1.62A20.77 20.77 0 0032 12zM16 30a21.48 21.48 0 01-4.64-2.16 22.56 22.56 0 01-3.11-2.48 18.07 18.07 0 01-2.12-2.45 20.91 20.91 0 01-2-3.25A18.8 18.8 0 013.05 17a18 18 0 01-1-5V4.33L16 2l14 2.33V12a18 18 0 01-1 5s-.07.22-.21.59a8 8 0 00-10.86 11.62c-.628.3-1.272.563-1.93.79zm8 0a6 6 0 110-12 6 6 0 010 12z"
  }), _react.default.createElement("path", {
    d: "M13.61 23l-.21-.13a14.87 14.87 0 01-4.33-4.1A12 12 0 017 13a1 1 0 00-2 0 13.31 13.31 0 002.56 7 16.16 16.16 0 005 4.58A1 1 0 0013.61 23z"
  })));
};

SvgExclamationShield32.propTypes = {
  size: _propTypes.default.oneOf(Object.keys(_sizes.alias)),
  color: _propTypes.default.string
};
var _default = SvgExclamationShield32;
exports.default = _default;